import core from './core'
import security from './security'
import activator from './activator'
import trackntrace from './trackntrace'
import redirects from './redirects'

export default [
  ...core,
  ...security,
  ...activator,
  ...trackntrace,
  ...redirects,
]



// WEBPACK FOOTER //
// ./src/router/routes/index.js